import Image, { ImageProps } from 'next/image';
import { useState, useEffect } from 'react';

export const myLoader = ({ src }: { src: string }) => src;

interface BPImageProps extends Omit<ImageProps, 'src'> {
  src: any;
  fallbackSrc?: string;
  layout?: 'fill' | 'fixed' | 'intrinsic' | 'responsive';
  objectFit?: React.CSSProperties['objectFit'];
  objectPosition?: React.CSSProperties['objectPosition'];
}

const BPImage = (
  {
    ref,
    ...props
  }: BPImageProps & React.RefAttributes<HTMLImageElement>
) => {
  // Extraímos as props legadas para que elas NÃO fiquem no 'rest'
  const {
    src,
    fallbackSrc,
    layout,
    objectFit,
    objectPosition,
    style,
    fill,
    priority,
    ...rest
  } = props;

  const [imgSrc, set_imgSrc] = useState(src);

  useEffect(() => {
    set_imgSrc(src);
  }, [src]);

  // Tradução para o padrão Next 14
  const isFill = layout === 'fill' || fill;

  const modernStyle: React.CSSProperties = {
    ...(!isFill ? { width: 'auto', height: 'auto' } : {}),
    ...style,
    ...(objectFit ? { objectFit } : {}),
    ...(objectPosition ? { objectPosition } : {}),
  };

  return (
    <Image
      {...rest} // Aqui o 'layout' e 'objectFit' já não existem
      ref={ref}
      src={imgSrc || '/img/placeholder.svg'}
      alt={props.alt || 'B-Parts'}
      unoptimized
      loader={myLoader}
      fill={isFill}
      priority={priority}
      style={modernStyle}
      onError={() => {
        if (fallbackSrc && imgSrc !== fallbackSrc) {
          set_imgSrc(fallbackSrc);
        }
      }}
    />
  );
};

BPImage.displayName = 'BPImage';

export default BPImage;
